/**
 * Diagnostic readings admin resource config (Index only).
 *
 * Labels come from Rails-rendered props (decisiv.telematics.* keys) — see
 * AdminKit::DiagnosticReadingsController#telematics_labels. Mounted from
 * Index.jsx, which builds this config from the labels prop before passing
 * it into createAdminResource.
 *
 * Read-only resource: no New/Edit/Delete.
 */
import React from 'react';
import { Tag } from '@decisiv/ui-components';

const buildConfig = (labels) => ({
  name: 'Diagnostic Reading',
  endpoint: '/internal_admin/admin_kit/diagnostic_readings',

  // The DR details link lives only in a dedicated "Details" column (PD-3507).
  // It used to sit on the Origin column, which read as "Origin details" and
  // confused users; Origin is now plain text and Faults is a plain count.
  columns: [
    { name: 'origin', title: labels.origin },
    { name: 'triggered_at', title: labels.triggeredAt },
    { name: 'vin', title: labels.vin },
    { name: 'device_id', title: labels.deviceId },
    { name: 'serial_number', title: labels.serialNumber },
    { name: 'chassis_id', title: labels.chassisId },
    { name: 'source_account', title: labels.sourceAccount },
    { name: 'srm_account_id', title: labels.srmId },
    { name: 'created_at', title: labels.createdAt },
    {
      name: 'fault_count',
      title: labels.faults,
      render: (record) => {
        const count = record.fault_count ?? 0;
        return count > 0 ? (
          <Tag intent="warning" text={String(count)} />
        ) : (
          <span style={{ color: '#888' }}>0</span>
        );
      },
    },
    {
      name: 'details',
      title: labels.readingDetail,
      type: 'link',
      linkText: labels.view,
    },
  ],

  filters: [
    { name: 'origin', label: labels.origin },
    { name: 'vin', label: labels.vin },
    { name: 'device_id', label: labels.deviceId },
    { name: 'serial_number', label: labels.serialNumber },
    { name: 'chassis_id', label: labels.chassisId },
    { name: 'source_account', label: labels.sourceAccount },
    { name: 'srm_id', label: labels.srmId },
  ],
});

export default buildConfig;
